module.exports = __webpack_public_path__ + "img/1000minds.png";